import { createClient } from '@/shared/api';
import type {
  EditPhysicianInterpretationMutation,
  EditPhysicianInterpretationMutationVariables,
} from '@/shared/api';
import EDIT_PHYSICIAN_INTERPRETATION_MUTATION from '../mutations/editPhysicianInterpretation';

/**
 * Saves the physician's interpretation of a report, optionally with the signature. Runs the editPhysicianInterpretation mutation and throws the returned message when it does not report success.
 *
 * @param id - Identifier of the report to update.
 * @param interpretation - Interpretation text to store.
 * @param signature - Optional physician signature to attach.
 * @returns A promise resolving once the interpretation has been saved.
 */
const handleEditPhysicianInterpretation = async (id: any, interpretation: any, signature?: any) => {
  const client = createClient();
  const editPhysicianInterpretationResult = await client.mutate<
    EditPhysicianInterpretationMutation,
    EditPhysicianInterpretationMutationVariables
  >({
    mutation: EDIT_PHYSICIAN_INTERPRETATION_MUTATION,
    variables: {
      id,
      interpretation,
      signature,
    },
  });
  const { data } = editPhysicianInterpretationResult;
  // API always returns this field for a resolved mutation; code already accessed it unconditionally.
  const { editPhysicianInterpretation } = data!;
  if (!editPhysicianInterpretation.isSuccess) {
    throw new Error(editPhysicianInterpretation.message ?? undefined);
  }
};

export default handleEditPhysicianInterpretation;
